
import React, { memo } from 'react';
import { Image, Text } from '../../../../ui-kit';
import './_user-profile.scss';












function UserProfile({
  imageUrl,
  name,
  isUser,
  height,
  width,
  hideProfile,
  isStoryboard,
  number
}) {
  const renderProfileImage = () => {
    if (isStoryboard) {
      return (
        <div className="number-circle">
          <span className="number">{number}</span>
        </div>);

    }
    return (
      <Image
        height={height || '20px'}
        width={width || '20px'}
        circular
        imageUrl={imageUrl}
        placeholderText={name}
        placeholderTextSize={9}
        backgroundSize="cover" />);


  };

  return (
    <div className="comment-user-profile gap-2">
      {!hideProfile && renderProfileImage()}
      <Text label noMargin ellipsisOverflow>
        {isUser ? 'You' : name}
      </Text>
    </div>);

}

export default memo(UserProfile);